import PersonaType from 'owa-service/lib/contract/PersonaType';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

export function getFirstEmailAddress(persona: PersonaType): EmailAddressWrapper {
    let emailAddress: EmailAddressWrapper;
    if (persona.EmailAddress) {
        emailAddress = persona.EmailAddress;
    }
    if (!emailAddress && persona.EmailAddresses && persona.EmailAddresses.length > 0) {
        emailAddress = persona.EmailAddresses[0];
    }

    return emailAddress;
}
